<div class="dialog">
  <div class="dialog-top">
    <h2 class="dialog-title short-text"> {{local_data.title}} </h2>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-button"
      mat-dialog-close>
      <circle opacity="0.05" cx="20" cy="20" r="20" fill="#0080FF" />
      <path opacity="0.8"
        d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z"
        fill="#0080FF" />
    </svg>
  </div>

  <mat-dialog-content class="dialog-flex">
    <form [formGroup]="formGroup1">
      <div class="dialog-box">
        @if (isEdit) {
          <label class="mb-2 input-label">{{variables.technology}} </label>
        }
        @else {
          <label class="mb-2 input-label mandatory"><span>*</span> {{variables.preTypes}} </label>
        }
        <mat-form-field class="form-field" appearance="outline">
          <mat-select formControlName="predTaskCtrl">
            @for (item of local_data.list; track item) {
            <mat-option title={{item.name}} [value]="item.name">
              {{item.name}}
            </mat-option>
            }
          </mat-select>
          @if (invalidPredTask) {
          <mat-hint class="error-hint">{{errorPredTask}}</mat-hint>
          }
        </mat-form-field>
      </div>

      @if (otherType) {
      <div class="dialog-box">
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.name}}</label>
        <mat-form-field
          [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidOtherTaskName, 'mat-form-field-invalid': invalidOtherTaskName}"
          class="form-field" appearance="outline">
          <input matInput formControlName="otherTaskNameCtrl">
          @if (invalidOtherTaskName) {
          <mat-hint class="error-hint">{{errorOtherTaskName}}</mat-hint>
          }
        </mat-form-field>
      </div>
      }



      <div>
        @if (isActionType) {
        <div class="complexDiv">
          @if (isActionType) {
          <mat-label class="input-label mandatory"><span>*</span> {{variables.complexityHours}}</mat-label>
          }
          <mat-form-field
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidCompLow, 'mat-form-field-invalid': invalidCompLow}"
            class="form-field" appearance="outline">
            <input matTooltip="Info about the action" type="number" step="0.01" matInput formControlName="compLowCtrl"
              placeholder={{variables.low1}}>
            @if (invalidCompLow) {
            <mat-hint class="error-hint">{{errorCompLow}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field class="form-field" appearance="outline">
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="3" maxlength="256" formControlName="detailsLowCtrl"
              placeholder={{variables.lowDescription}}></textarea>
          </mat-form-field>
          <mat-form-field
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidCompMid, 'mat-form-field-invalid': invalidCompMid}"
            class="form-field" appearance="outline">
            <input matTooltip="Info about the action" type="number" step="0.01" matInput formControlName="compMidCtrl"
              placeholder={{variables.medium1}}>
            @if (invalidCompMid) {
            <mat-hint class="error-hint">{{errorCompMid}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field class="form-field" appearance="outline">
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="3" maxlength="256" formControlName="detailsMedCtrl"
              placeholder={{variables.mediumDescription}}></textarea>
          </mat-form-field>
          <mat-form-field
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidCompHi, 'mat-form-field-invalid': invalidCompHi}"
            class="form-field" appearance="outline">
            <input matTooltip="Info about the action" type="number" step="0.01" matInput formControlName="compHiCtrl"
              placeholder={{variables.high1}}>
            @if (invalidCompHi) {
            <mat-hint class="error-hint">{{errorCompHi}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field class="form-field" appearance="outline">
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="3" maxlength="256" formControlName="detailsHighCtrl"
              placeholder={{variables.highDescription}}></textarea>
          </mat-form-field>
          @if (isActionType) {
          <mat-label class="input-label mandatory"><span>*</span> {{variables.tshirtSize}} {{variables.inDays}}</mat-label>
          }
          <mat-form-field
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidTshirtXS, 'mat-form-field-invalid': invalidTshirtXS}"
            class="form-field" appearance="outline">
            <input matTooltip="T-shirt size XS" type="number" matInput formControlName="tshirtXSCtrl" placeholder="XS"
              step="0.01" min="0" (input)="validateDecimal($event)">
            @if (invalidTshirtXS) {
            <mat-hint class="error-hint">{{errorTshirtXS}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidTshirtS, 'mat-form-field-invalid': invalidTshirtS}"
            class="form-field" appearance="outline">
            <input matTooltip="T-shirt size S" type="number" matInput formControlName="tshirtSCtrl" placeholder="S"
              step="0.01" min="0" (input)="validateDecimal($event)">
            @if (invalidTshirtS) {
            <mat-hint class="error-hint">{{errorTshirtS}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidTshirtM, 'mat-form-field-invalid': invalidTshirtM}"
            class="form-field" appearance="outline">
            <input matTooltip="T-shirt size M" type="number" matInput formControlName="tshirtMCtrl" placeholder="M"
              step="0.01" min="0" (input)="validateDecimal($event)">
            @if (invalidTshirtM) {
            <mat-hint class="error-hint">{{errorTshirtM}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidTshirtL, 'mat-form-field-invalid': invalidTshirtL}"
            class="form-field" appearance="outline">
            <input matTooltip="T-shirt size L" type="number" matInput formControlName="tshirtLCtrl" placeholder="L"
              step="0.01" min="0" (input)="validateDecimal($event)">
            @if (invalidTshirtL) {
            <mat-hint class="error-hint">{{errorTshirtL}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidTshirtXL, 'mat-form-field-invalid': invalidTshirtXL}"
            class="form-field" appearance="outline">
            <input matTooltip="T-shirt size XL" type="number" matInput formControlName="tshirtXLCtrl" placeholder="XL"
              step="0.01" min="0" (input)="validateDecimal($event)">
            @if (invalidTshirtXL) {
            <mat-hint class="error-hint">{{errorTshirtXL}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidTshirtXXL, 'mat-form-field-invalid': invalidTshirtXXL}"
            class="form-field" appearance="outline">
            <input matTooltip="T-shirt size XXL" type="number" matInput formControlName="tshirtXXLCtrl"
              placeholder="XXL" step="0.01" min="0" (input)="validateDecimal($event)">
            @if (invalidTshirtXXL) {
            <mat-hint class="error-hint">{{errorTshirtXXL}}</mat-hint>
            }
          </mat-form-field>
        </div>
        }
      </div>

      @if (profiles.length > 0) {
      <div class="dialog-box">
        <label class="mb-2 input-label">{{variables?.center || 'Centro'}}</label>
        <mat-form-field class="form-field" appearance="outline">
          <mat-select formControlName="centerCtrl" (selectionChange)="onCenterChange($event.value)">
            <mat-option value="">{{variables?.allCenters || 'Todos los centros'}}</mat-option>
            @for (c of centers; track c) {
            <mat-option [value]="c">{{c}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }

      @if (profiles.length > 0) {
      <div class="dialog-box">
        <label class="mb-2 input-label">{{variables?.profile || 'Perfil'}}</label>
        <mat-form-field class="form-field" appearance="outline">
          <mat-select formControlName="profileCtrl">
            <mat-option value="">{{variables?.noProfile || 'Sin perfil'}}</mat-option>
            @for (p of filteredProfiles; track p) {
            <mat-option [value]="p.id">
              {{p.name}} ({{p.costPerHour}} €/h)
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
    </form>
    <div>
      <mat-dialog-actions class="button-group">
        <app-button typeBtn="secondary" message="{{variables.cancel}}" mat-dialog-close></app-button>
        <app-button typeBtn="primary" (click)="doAction()" message="{{variables.save}}"></app-button>
      </mat-dialog-actions>
    </div>
  </mat-dialog-content>

</div>